import { render, staticRenderFns } from "./appData.vue?vue&type=template&id=3ed1dd6a&scoped=true&"
import script from "./appData.vue?vue&type=script&lang=js&"
export * from "./appData.vue?vue&type=script&lang=js&"
import style0 from "./appData.vue?vue&type=style&index=0&id=3ed1dd6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1dd6a",
  null
  
)

export default component.exports